const initGlobalVariables = function() {
  window.$body = $("body");
  window.isMenuOpen = false;
};

module.exports = initGlobalVariables();
